import React, { useState } from 'react';
import styles from './SearchMedicamentRecordListItemMedicament.module.scss';
import Text from '../../../Base/Text/Text';
import LinkButton from '../../../Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { getMomentDate } from '../../../../Utils/dates.util';

export interface SearchMedicamentRecordListItemMedicamentScheme {
	predpisId?: string;
	title: string;
	subtitle?: string;
	issuedAt?: string;
	items: {
		key?: string;
		type?: string;
		title: string;
		value: string | number;
	}[];
	children: {
		key?: string;
		title: string;
		children: {
			key?: string;
			title?: string;
			value: string | number;
		}[];
	}[];
}

interface Props {
	item: SearchMedicamentRecordListItemMedicamentScheme;
	onIssueAgain?: (item: SearchMedicamentRecordListItemMedicamentScheme) => void;
}

const SearchMedicamentRecordListItemMedicament: React.FC<Props> = ({
	item,
	onIssueAgain,
}) => {
	const [isDetailOpen, setIsDetailOpen] = useState(false);

	const handleToggleDetail = () => {
		setIsDetailOpen(!isDetailOpen);
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.content}>
				<>
					<div className={styles.medicament}>
						<div className={styles.title}>
							{item.title} <span>{item.subtitle}</span>
						</div>
						{item.issuedAt && (
							<div className={styles.date}>
								<Text tx={'base.issued'} inline firstUpper />:{' '}
								{getMomentDate(item.issuedAt).format('DD.MM.yyyy')}
							</div>
						)}
					</div>
					<div className={styles.prescriptBy}>
						{item.items.map((subItem, index) => (
							<div
								key={subItem.key ?? `${item.title}-${index}`}
								className={styles.prescriptByItem}>
								<div className={styles.name}>{subItem.title}:</div>
								<div className={styles.value}>{String(subItem.value)}</div>
							</div>
						))}
					</div>
					{isDetailOpen && (
						<>
							{item.children.map((child, childIndex) => (
								<div
									key={
										child.key ??
										`${item.title}-section-${child.title}-${childIndex}`
									}>
									<div className={styles.detailTitle}>{child.title}</div>
									<div className={styles.prescriptBy}>
										{child.children.map((subChild, rowIndex) => (
											<div
												key={`row--${rowIndex}`}
												className={styles.prescriptByItem}>
												{subChild.title && (
													<div className={styles.name}>{subChild.title}:</div>
												)}
												<div className={styles.value}>
													{String(subChild.value)}
												</div>
											</div>
										))}
									</div>
								</div>
							))}
						</>
					)}
				</>
			</div>
			<div className={styles.controls}>
				<LinkButton
					onClick={handleToggleDetail}
					title={'base.detail'}
					firstUpper
					theme={Theme.BLUE}
				/>
				<LinkButton
					onClick={() => onIssueAgain?.(item)}
					title='component.permanentMedicationItem.issueAgain'
					firstUpper
					theme={Theme.BLUE}
				/>
			</div>
		</div>
	);
};

export default SearchMedicamentRecordListItemMedicament;
